import React from 'react';
import * as styles from './TutorialFixedContainer.module.scss';

interface TutorialFixedContainerProps {
  children: React.ReactNode;
}

const TutorialFixedContainer = ({ children }: TutorialFixedContainerProps) => (
  <div className={styles.container}>{children}</div>
);

export default TutorialFixedContainer;
